<template>
	<div class="public-course">
		<div v-if="shows == '1'">
			<div id="headers">
      <!-- 第一种方案 -->
			<!-- <div class="player-container">
				<video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
			</div> -->
			 <!-- 第二种方案 -->
				<div class='videoPlayer' v-if="shareVideo">
					<video-player class="video-player vjs-custom-skin"
						ref="videoPlayer"
						:playsinline="true"
						:options="playerOptions"
						@play="onPlayerPlay($event)"
						@pause="onPlayerPause($event)"
						@statechanged="playerStateChanged($event)"
						>
					</video-player>
				</div>
				<!-- 以下临时无用，因为以上视频既支持，嵌入图片，也支持嵌入视频 -->
				<div v-else>
					<img class="header" :src="shareLogo">
					<img @click="goDown" class="imgs" src="../../assets/img/bf.png" />
				</div>
				<!-- 第三种方案 -->
				<!-- <video autoplay="autoplay" width="100%" height="210" id="videos" preload="auto" controls style="background:rgba(0,0,0,1);">
					<source src="http://video.jt11.com.cn/1f654e3575cd4cca89b5344e39d19817/3c057dd1af4445ce82c1e962c04a3cd1-fbd5f881bf2dd915521a43d842301600-ld.mp4" type="video/mp4">
				</video> -->
				
			</div>
			<div class="content">
				<van-tabs v-model="activeName">
					<van-tab title="详情" name="detail">
						<div class="content-row">
							<div class="content-n-row">
								{{courseName}}
							</div>
							<div class="content-n-row article" v-if="sectionTotal == ''">
								共{{ chapterTotal }}章
							</div>
							<div class="content-n-row article" v-else>
								共{{ chapterTotal }}章{{ sectionTotal }}节
							</div>
						</div>

						<div class="content-row two" v-for="(item,index) in courseLecturer">
							<div class="teacher" @click.stop="teacherSpecial(item.id)">
								<p class="content-row-left">
									<img :src="item.headImgUrl" />
								</p>
								<div class="content-row-right">
									<div class="name">{{item.name}}</div>
									<!-- <div class="desc" v-bind:class="[isCollapse ? noAllDesc : allDesc, desc]"> -->
									<div class="desc">
										{{ item.desc }}
									</div>
									<span v-if="item.introduce && item.introduce.length>60">
										<div v-if="item.isZk" class="introduce" @click.stop="collapse(1,index)">展开介绍</div>
										<div v-if="!item.isZk" class="introduce" @click.stop="collapse1(2,index)">收回介绍</div>
										<!-- <div v-if="isCollapse" class="introduce" @click="collapse(1,index)">展开介绍</div>
                  <div v-if="!isCollapse" class="introduce" @click="collapse(2,index)">收回介绍</div> -->
									</span>
								</div>
							</div>
						</div>

						<div class="content-row three">
							<div class="content-n-row"> 
								课程介绍
							</div>
							<div class="content-n-row course-desc">
								{{ introduction }}
							</div>
						</div>
						<span v-if="channeFlag == 1">
							<div class="down-app">更多精彩内容请下载[交道]APP</div>
							<div class="go-look" @click="goDown">去看看</div>
							<img class="rcode" src="../../assets/img/kt.png">
						</span>
					</van-tab>

					<van-tab title="目录" name="dist">
						<dist :courseCatalogue="courseCatalogue" :courseContent="courseContent" :playerObj="playerObj" :bf="bf"></dist>
					</van-tab>
					<van-tab title="留言" name="talk">
						<talk></talk>
					</van-tab>
				</van-tabs>
			</div>
		</div>

		<div v-if="shows == '2'" id="sc">
			<img src="../../assets/img/sc.png" />
			<p>抱歉，该内容已下线</p>
		</div>
		<div v-if="shows == '3'" id="sc">
			<img src="../../assets/img/sc.png" />
			<p>抱歉，该内容已不存在</p>
		</div>

	</div>
</template>
<script>
//引入video样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
//引入hls.js
// import 'videojs-contrib-hls.js/src/videojs.hlsjs'
	import {
		Loading,
		Tab,
		Tabs,
		Card,
		Dialog
	} from 'vant'
	import request from '@/utils/request'
	import dist from "./components/dist";
	import talk from "./components/talk";
	export default {
		name: 'public-course',
		components: {
			dist,
			talk,
			[Loading.name]: Loading,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Card.name]: Card,
			[Dialog.name]: Dialog,
			courseList: [],
			subLen: 50, //k
		},
		props: {
			msg: String
		},
		watch: {
			courseLecturer() {
				this.courseList = this.courseLecturer
			}
		},
		data() {
			return {
				activeName: 'detail',
				isCollapse: true,
				desc: 'desc',
				noAllDesc: 'noAllDesc',
				allDesc: 'allDesc',
				shareLogo: '', //logo
				shareVideo:'',//分享的视频
				courseName: '', //课程名称
				chapterTotal: '', //共几章
				sectionTotal: '', //共多少节
				courseLecturer: [], //讲师信息
				introduction: '暂无相关说明', //课程介绍
				courseCatalogue: [], //章节内容
				courseContent:[], //课程内容
				courseId: '', //课程id
				category: '', //课程分类类型
				shows: '1',
				channeFlag: 1,
				playerObj:Object,
				bf:false,//默认不播放
				playerOptions: {
            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            controls: true, //控制条
            preload: 'auto', //视频预加载
            muted: false, //默认情况下将会消除任何音频。
            loop: false, //导致视频一结束就重新开始。
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
           	sources: [{
							//类型
							type: "video/mp4",
							//url地址
							src:''//this.shareVideo,
							//src: 'http://video.jt11.com.cn/1f654e3575cd4cca89b5344e39d19817/3c057dd1af4445ce82c1e962c04a3cd1-fbd5f881bf2dd915521a43d842301600-ld.mp4' 
					}],
            poster: '',//this.shareLogo, //你的封面地址http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg
            width: document.documentElement.clientWidth,
						notSupportedMessage: ' ', //此视频暂无法播放，请稍后再试
						controlBar: {
							timeDivider: true,
							durationDisplay: true,
							remainingTimeDisplay: false,
							//全屏按钮
							//fullscreenToggle: true  
					}
        },
				playerOptions1: {
					//播放速度
					playbackRates: [0.5, 1.0, 1.5, 2.0], 
					//如果true,浏览器准备好时开始回放。
					autoplay: false, 
					// 默认情况下将会消除任何音频。
					muted: false, 
					// 导致视频一结束就重新开始。
					loop: false, 
					// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					preload: 'auto', 
					language: 'zh-CN',
						// 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					aspectRatio: '16:9',
						// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					fluid: true,
					sources: [{
							//类型
							type: "video/mp4",
							src: 'http://video.jt11.com.cn/1f654e3575cd4cca89b5344e39d19817/3c057dd1af4445ce82c1e962c04a3cd1-fbd5f881bf2dd915521a43d842301600-ld.mp4' 
					}],
					//你的封面地址
					poster: '', 
						//允许覆盖Video.js无法播放媒体源时显示的默认信息。
					notSupportedMessage: '',//此视频暂无法播放，请稍后再试
					controlBar: {
							timeDivider: true,
							durationDisplay: true,
							remainingTimeDisplay: false,
							//全屏按钮
							fullscreenToggle: true  
					}
				}
			}
		},
		mounted() {
			if (window.history && window.history.pushState) {
			    history.pushState(null, null, document.URL);
			    window.addEventListener('popstate', this.fun, false);//false阻止默认事件
			  }
			this.playerObj = this.$refs.videoPlayer
			this.courseId = this.$root.getUrlParms("courseId")||'';//623833196538101760;
			this.category = this.$root.getUrlParms("category")||'';//3;
			this.channeFlag = this.$root.getUrlParms("channeFlag")||1;//默认为分享页1（有下载和去看看内容）  wap页 2
			this.initData();
		  
		},
		methods: {
			// 刷新
			fun(){
				//alert(this.channeFlag)
				if(this.channeFlag != 1){
				this.$router.push({
					name: 'HomePage',
					query: {
						
					}
				})
				}
				
				// location.reload();
				// this.$router.go(-1);
				// alert(11111)
			},
			onPlayerPlay(player) {
				//alert(1)
        // console.log('player play!', player)
			},
			onPlayerPause(player) {
				//alert(2)
        // console.log('player pause!', player)
			},
			playerStateChanged(player){
				if(player&&player.play){
					this.bf = true;
				}
				if(player&&player.pause){
					this.bf = false;
				}
			//	console.log('player 改变!', player)
			},
			collapse(status, index) {
				this.courseLecturer.forEach((item, index1) => {
					if (index == index1) {
						item.isZk = false;
						item.desc = item.introduce;
						//复杂数据设置，this.courseLecturer更改的对象，index1 当前序号， item 改变的列
						this.$set(this.courseLecturer, index1, item);
					}
				})
				// if(status == 1){
				//   this.isCollapse = false;
				// }else{
				//   this.isCollapse = true;
				// }
			},
			collapse1(status, index) {
				this.courseLecturer.forEach((item, index1) => {
					if (index == index1) {
						if (item.introduce.length > 52) {
							item.isZk = true;
							item.desc = item.introduce.substring(0, 52) + "..."
						} //复杂数据设置，this.courseLecturer更改的对象，index1 当前序号， item 改变的列
						this.$set(this.courseLecturer, index1, item);
					}
				})
			},
			goDown() {
				let _this = this;
				// window.location.href = "jt11trafficnews://";
				setTimeout(function() {
				  Dialog.confirm({
				    title: '',
				    message: '即将离开当前应用'
				  }).then(() => {
				    window.location.href="https://upgrade.jiaodao11.com/mobile/index.html?businessId="+_this.courseId+"&type=3";
				    // window.location.href="https://upgrade-test.jiaodao11.com/mobile/index.html?businessId="+_this.courseId+"&type=3";
						
						
				  }).catch(() => {
				    // on cancel
				  });
				},300)

				// this.$root.download();
			},
			teacherSpecial(id){//老师专辑页A
				this.$router.push({name: 'LecturerPage',query: {id:id} })
			},
			initData() {
				let _this = this;
				let url = "";
				if(this.channeFlag == 1){//分享接口
					url = Global.env + Global.apiCore.shareCourse + "/" + this.courseId + "/" + this.category;
				}else{//未分享接口 -- 
					url = Global.env + Global.apiCore.noShareCourse + "?courseId=" + this.courseId + "&category=" + this.category;
				}
				return new Promise((resolve, reject) => {
					console.log(_this.tableParams)
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							//this.loading = false;
							if (response && response.data) {
								let dataObj = response.data;
								_this.shareLogo = dataObj.courseContent.shareLogo || ''; //logo
								_this.shareVideo = dataObj.courseContent.shareVideo || ''; //视频为空获取 视频图片
								_this.playerOptions.poster = _this.shareLogo;//样片图片
								_this.playerOptions.sources[0].src = _this.shareVideo;//"http://video.jt11.com.cn/1f654e3575cd4cca89b5344e39d19817/3c057dd1af4445ce82c1e962c04a3cd1-fbd5f881bf2dd915521a43d842301600-ld.mp4";//视频为空获取 视频图片
								_this.courseName = dataObj.courseContent.courseName || '无课程';
								_this.introduction = dataObj.courseContent.introduction || '暂无相关说明' //暂无相关说明
								_this.chapterTotal = dataObj.courseContent.chapterTotal || 0;
								_this.sectionTotal = dataObj.courseContent.sectionTotal || 0;
								_this.courseLecturer = dataObj.courseContent.courseLecturer || []; //讲师信息
								_this.courseCatalogue = dataObj.courseCatalogue || [];
								_this.courseContent = dataObj.courseContent || [];
								
								_this.courseLecturer.forEach((item) => {
									if (item && item.introduce) {
										if (item.introduce.length > 50) {
											item.isZk = true;
											item.desc = item.introduce.substring(0, 50) + "..."
										} else {
											item.desc = item.introduce;
										}
									}
								})
								//console.log(_this.courseLecturer)
							}
							return resolve()
						} else if (response.resultCode === "20010011") {
							_this.shows = '2'
						} else if (response.resultCode === "20010010") {
							_this.shows = '3'
						} else {
							return reject(response.resultDesc);
						}
					}).catch(error => {
						return reject(error);
					})
				})
			},
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scope>
	.public-course {
		text-align: center;
		#headers {
			width: 100%;
			height: 4.37rem;
			overflow: hidden;
			position: relative;
		}
		.header {
			width: 100%;
			height: 4.37rem;
		}
		.imgs {
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
		}
		.van-tabs--line .van-tabs__wrap {
			height: 0.8rem;
			background: transparent;
		}
		.content {
			.van-tab {
				line-height: .8rem;
			}

			.van-tab--active {
				color: red;
			}

			.van-tabs__line {
				height: 0.02rem;
				width: .66rem !important;
			}

			.van-ellipsis {
				font-size: 0.3rem;
				font-family: 'PingFangSC-Regular';
			}

			.content-row {
				width: 7rem;
				height: auto;
				font-size: .30rem;
				text-align: left;
				margin: .2rem auto;
				border-radius: 8px;
				box-shadow: 0px 0px 0.4rem #e3e1e1;

				.content-n-row {
					padding: .26rem;
				}

				.article {
					padding-top: 0;
					color: #999;
				}

				.teacher {
					padding-bottom: .6rem;
				}
			}

			.content-row-left {
				float: left;
				padding-left: .3rem;
				padding-right: .3rem;

				& img {
					width: 1.5rem;
					height: 2.08rem;
				}
			}

			.content-row-right {
				padding-top: .2rem;

				& .name {
					margin-top: .2rem;
					font-size: .34rem;
					color: #333;
				}

				& .desc {
					font-size: .28rem!important;
					padding-right: .16rem;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					overflow: hidden;

				}

				& .noAllDesc {
					-webkit-line-clamp: 3;
				}

				& .allDesc {
					-webkit-line-clamp: initial;
				}

				& .introduce {
					color: red;
					font-size: .22rem;
					float: right;
					margin: .12rem;
				}
			}

			.three {
				height: auto;

				.course-desc {
					margin-top: -.4rem;
					color: #666;
					font-size: .28rem!important;
				}
			}

			.down-app {
				font-size: .3rem;
				color: #000;
				letter-spacing: 2px;
				margin-top: .5rem;
			}

			.go-look {
				color: #fff;
				background: linear-gradient(bottom, #F63C45, #FF979C);
				width: 4.6rem;
				height: .8rem;
				color: .3rem;
				font-size: .3rem;
				border-radius: .5rem;
				display: block;
				margin: 0 auto;
				line-height: .8rem;
				margin-top: .5rem;
			}

			.rcode {
				width: 2.3rem;
				height: 2.16rem;
				margin-top: .5rem;
			}

			.two {
				height: auto;
				min-height: 2.68rem;
				margin-top: .2rem;

				.van-card__thumb {
					width: 1.52rem;
					height: 2.08rem;
				}

				.van-card {
					background: #fff;
					border-radius: 8px;
					padding: 0.3rem 0.22rem;

					.van-image__img {
						object-fit: cover !important;
					}
				}

			}
		}
		.videoPlayer{
			display: inline-block;
			width: 7.5rem;
			height: 338px;
			text-align: center;
			line-height: 100px;
			border: 1px solid transparent;
			border-radius: 4px;
			overflow: hidden;
			background: #fff;
			position: relative;
			box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
			margin-right: 4px;
  	}
		// .videoPlayer:hover{
		// 	display: block;
		// }
	}
</style>
